import { Link } from "react-router-dom";
import { site } from "@/mocks/site";

function PlatformPrinciples() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100">
      <div className="w-full px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="relative h-72 w-full overflow-hidden rounded-lg border border-background-200 bg-background-200 md:h-96">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20reading%20room%20with%20tall%20archive%20shelves%20full%20of%20document%20boxes%20and%20warm%20pendant%20lamps%2C%20sepia%20and%20deep%20ochre%20tones%2C%20soft%20directional%20light%20with%20long%20shadows%2C%20editorial%20architectural%20photography%2C%20no%20text%20no%20people&width=1000&height=800&seq=principles-baoliao-01&orientation=landscape"
              alt="爆料平台线索归档与内容核实工作场景"
              title="爆料平台内容原则与线索归档"
              className="h-full w-full object-top"
            />
            <div className="absolute bottom-5 left-5 right-5 rounded-lg border border-background-50/20 bg-foreground-950/70 p-4 backdrop-blur">
              <p className="font-heading text-sm leading-relaxed text-background-100 md:text-base">
                “不替任何人下结论，也不让任何一条材料石沉大海。”
              </p>
            </div>
          </div>

          <div>
            <span className="mb-3 inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-primary-400" />
              内容原则
            </span>
            <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
              我们如何对待每一条爆料
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              {site.description}
            </p>

            <ul className="mt-7 space-y-4">
              {site.principles.map((principle) => (
                <li key={principle} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-check-line text-sm" />
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-700">{principle}</span>
                </li>
              ))}
            </ul>

            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
            >
              了解平台定位
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PlatformPrinciples;